export enum SurveyStateStatusEnum {
	Created = 'Created',
	Delivered = 'Delivered',
	Completed = 'Completed',
}

export const SurveyStateStatusArray = [SurveyStateStatusEnum.Created, SurveyStateStatusEnum.Delivered];
